module.exports = __webpack_public_path__ + "static/media/onboardingSecond.b5a332a0.jpeg";